import React from 'react';
import styles from './CurrencyEntityConfig.scss';

const CurrencyEntityConfig = () => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>Currency Type Entity</div>
      <div className={styles.subtitle}>
        Currency entity is used to collect currency type and value.
      </div>
      <div className={styles.group}>
        <div className={styles.head}>Example</div>
        <div className={styles.row}>
          <div className={styles.key}>Bot</div>
          <div className={styles.value}>
            What loan amount are you looking for?
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>User</div>
          <div className={styles.value}>$20,000</div>
        </div>

        <div className={styles.group}>
          <div className={styles.row}>
            <div className={styles.key}>If the user says</div>
            <div className={styles.value}>$20,000</div>
          </div>
          <div className={styles.row}>
            <div className={styles.key}>It will detect</div>
            <div className={styles.value}>unit: USD, value: 20000</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrencyEntityConfig;
